import { Feature_Type_Config, Query_Root } from 'src/@types/graphql'
import { SupportedLocale } from 'src/@types'
import { Client } from 'urql'
import {
  queryAllFeatureTypeConfigs,
  queryFeatureTypeConfigByIdAsSelectOption,
} from 'src/screens/administration/configuration-management/features-configuration/feature-types/featureTypesConfigQueries'
import { sortBy } from 'lodash'
import { CONFIGURATION_STATUS, CONFIGURATION_STATUS_TYPE } from 'src/shared/constants/constants'

export const canUpdateFeatureGroupConfigStatus = (
  selectedFeatureTypeId: number,
  selectedStatus: CONFIGURATION_STATUS_TYPE,
  featureTypeOptions: Feature_Type_Config[],
): boolean => {
  const isActiveSelected = selectedStatus === CONFIGURATION_STATUS.ACTIVE

  if (isActiveSelected) {
    return featureTypeOptions.some((featureType) => featureType.id === selectedFeatureTypeId && featureType.active)
  }

  return true
}

export const fetchAllFeatureTypes = (urqlClient: Client, locale: SupportedLocale) => async () => {
  const { data, error } = await urqlClient
    .query<{
      feature_type_config: Query_Root['feature_type_config']
    }>(queryAllFeatureTypeConfigs, {})
    .toPromise()

  if (error || !data?.feature_type_config) {
    throw new Error('Resource not found')
  }

  const fetchedFeatureTypes = sortBy(data.feature_type_config, [`names.${locale}`])
  return { fetchedFeatureTypes }
}

export const fetchFeatureTypeById = (urqlClient: Client, featureTypeId: number) => async () => {
  const { data, error } = await urqlClient
    .query<{
      feature_type_config: Query_Root['feature_type_config']
    }>(queryFeatureTypeConfigByIdAsSelectOption, {
      featureTypeId,
    })
    .toPromise()

  if (error || !data?.feature_type_config?.[0]) {
    throw new Error('Resource not found')
  }

  const fetchedFeatureType = data.feature_type_config[0]
  return { fetchedFeatureType }
}
